import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/shared/api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Mantém o cache por mais tempo para a navegação entre telas reusar os dados.
      gcTime: 60 * 60_000,
      // Sem revalidação automática. Os dados só voltam a ser buscados no refresh
      // da página, na primeira visita (cache vazio) ou após uma mutação invalidar a query.
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: (failureCount, error) => {
        // Não insistir em erros do cliente (4xx).
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
